import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { JOBS_QUERIES } from "~/shared/api/jobs/jobs.queries";
import { notFound } from "~/shared/util/notFound";

export function jobGamePlansViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { gamePlanId } = params;

  if (!gamePlanId) {
    return notFound();
  }

  queryClient.prefetchQuery(JOBS_QUERIES.gamePlanDetail(gamePlanId));

  return null;
}
